const GOLDEN_ANGLE = 137.508;
export function getLineHue(idx: number) {
  return (idx * GOLDEN_ANGLE) % 360;
}

export const getSaturation = (idx: number) => {
  return 60 + ((idx * 17) % 20);
};

export const getLightness = (idx: number) => {
  return 50 + ((idx * 13) % 20);
};

export interface LineColorOptsType {
  hue: number;
  saturation?: number;
  lightness?: number;
  alpha?: number;
}

export interface SkyColor {
  hue: number;
  saturation: number;
  lightness: number;
}

export function getLineColor({ hue, saturation, lightness, alpha }: LineColorOptsType) {
  return `hsla(${hue}, ${saturation ?? 75}%, ${lightness ?? 75}%, ${alpha ?? 1})`;
}

export interface LineChartDataEntry<T> {
  data: {
    time: number;
    volume: number;
    volumeUSD: number;
    details: {
      token: string;
      volume: number;
      volumeUSD: number;
      price: number;
    }[];
  }[];
  label?: string;
  color?: string;
  id: string;
  currency?: string;
  token?: string;
  exchangeName?: string;
  exchangeId?: number;
  tokenType?: string;
  meta?: T extends Record<string, unknown> ? T : never;
}

export type LineChartRange = 'Week' | 'Year';

export const BASE_TOKEN_COLOR_NUMBER = 2;
export const STABLES_COLOR_NUMBER = 0;

const pieColors = [
  { hue: 212, saturation: 36, lightness: 48 }, // #4F78A7  rgb(79,120,167)
  { hue: 20, saturation: 10, lightness: 70 },
  { hue: 175, saturation: 31, lightness: 59 },
  { hue: 390, saturation: 60, lightness: 61 },
  { hue: 212, saturation: 36, lightness: 35 }, // #7AB7B2  rgb(118,183,178)
  { hue: 49, saturation: 82, lightness: 42 }, // #EBCB44  rgb(237,201,73)
  { hue: 354, saturation: 100, lightness: 81 }, // #FF9FA8  rgb(255,159,168)
  { hue: 31, saturation: 86, lightness: 45 }, // #EF8F2A  rgb(242,142,44)
  { hue: 22, saturation: 24, lightness: 49 }, // #9C755F  rgb(156,117,95)
  { hue: 359, saturation: 70, lightness: 61 }, // #E2575B  rgb(225,87,89)
  { hue: 113, saturation: 34, lightness: 47 }, // #5AA050  rgb(89,161,79)
  { hue: 316, saturation: 25, lightness: 58 }, // #B07AA1  rgb(175,122,161)
];

/* const pieColors = [
  { hue: 203, saturation: 96, lightness: 36 },
  { hue: 212.22, saturation: 48, lightness: 40 }, // Base token color
  { hue: 209.44, saturation: 48, lightness: 53 },
  { hue: 206.67, saturation: 34, lightness: 46 },
  { hue: 203.89, saturation: 50, lightness: 54 },
  { hue: 201.11, saturation: 36, lightness: 47 },
  { hue: 198.33, saturation: 52, lightness: 54 },
  { hue: 195.56, saturation: 38, lightness: 47 },
  { hue: 192.78, saturation: 54, lightness: 55 },
  { hue: 190.0, saturation: 40, lightness: 48 },
]; */

export const PALETTE_SIZE = pieColors.length;

export const BASE_TOKEN_COLOR: SkyColor = pieColors[BASE_TOKEN_COLOR_NUMBER];
export const STABLES_COLOR: SkyColor = pieColors[STABLES_COLOR_NUMBER];

export function getPieHue(idx: number) {
  return idx % pieColors.length;
}

export function getPieColor(idx: number) {
  const { hue, saturation, lightness } = pieColors[getPieHue(idx)];
  return `hsla(${hue}, ${saturation}%, ${lightness}%, 1)`;
}
